import { getCalendar, getCounterParts } from '../../services/bussinesRounds.service'
import { UPDATE_CALENDAR, UPDATE_COUNTERPARTS, UPDATE_CONFIGURATION, LOCK_UI, UNLOCK_UI, UPDATE_FILTERS, UPDATE_PERMISSIONS } from '../actionsTypes'
import { resolveEffectiveLeadRetrieval } from '../../utils/leadRetrievalAccess'

const DEFAULT_BUSINESS_ROUND_MATCHMAKING_MODE = 'RegistrationType';

export const updateCalendar = () => {
    return async (dispatch) => {
        try {
            const payload = await getCalendar()

            dispatch({
                type: UPDATE_CALENDAR,
                payload
            })
        } catch (error) {
            console.log(error);
        }
    }
}

export const updateCounterparts = () => {
    return async (dispatch) => {
        try {
            const payload = await getCounterParts()

            dispatch({
                type: UPDATE_COUNTERPARTS,
                payload
            })
        } catch (error) {
            console.log(error);
        }
    }
}

export const lockUI = () => {
    return {
        type: LOCK_UI
    }
}

export const unLockUI = () => {
    return {
        type: UNLOCK_UI
    }
}

export const setCalendar = (myMeetings) => {
    return {
        type: UPDATE_CALENDAR,
        payload: myMeetings
    }
}

export const setCounterparts = (myCounterparts) => {
    return {
        type: UPDATE_COUNTERPARTS,
        payload: myCounterparts
    }
}

export const setConfiguration = (configuration) => {
    return {
        type: UPDATE_CONFIGURATION,
        payload: configuration
    }
}

// Normaliza los 4 campos de permisos del usuario y los mete en el store.
// Acepta el shape crudo de /authenticate o /personalPackage:
//   { businessRoundEnabled, leadRetrievalEnabled, businessRoundMatchmakingMode, registrationGroups }
// Defaults seguros (compat con backends viejos):
//   businessRoundEnabled    → true
//   matchmakingMode         → 'RegistrationType' (modo legacy)
//   registrationGroups      → []
//   leadRetrievalEnabled    → resolveEffectiveLeadRetrieval(rootFlag, groups)
export const setPermissions = (raw) => {
    const source = raw || {};
    const groups = Array.isArray(source.registrationGroups)
        ? [...source.registrationGroups].sort((a, b) => (a.priority || 0) - (b.priority || 0))
        : [];
    const payload = {
        businessRoundEnabled: source.businessRoundEnabled == null ? true : source.businessRoundEnabled,
        businessRoundMatchmakingMode: source.businessRoundMatchmakingMode || DEFAULT_BUSINESS_ROUND_MATCHMAKING_MODE,
        registrationGroups: groups,
        leadRetrievalEnabled: resolveEffectiveLeadRetrieval(source.leadRetrievalEnabled, groups),
    };
    return {
        type: UPDATE_PERMISSIONS,
        payload,
    };
}

// Toggle puntual del opt-in del usuario en BR (block/unblock calendar).
// Aprovecha el merge parcial del reducer.
export const setBusinessRoundEnabled = (value) => ({
    type: UPDATE_PERMISSIONS,
    payload: { businessRoundEnabled: !!value },
});

export const setFiltersData = (categories, investmentRanges) => {
    const categoriesTransformed = categories.map((category, index) => ({
        id: index + 1,
        label: category,
        checked: true,
    }));
    categoriesTransformed.unshift({ id: 0, label: 'Todas los rubros', checked: true });
    const investmentRangesTransformed = {
        lowEnd: parseInt(investmentRanges[0]),
        highEnd: parseInt(investmentRanges[1]),
    };
    return {
        type: UPDATE_FILTERS,
        payload: { categories: categoriesTransformed, investmentRanges: investmentRangesTransformed }
    }
}
// export const blockCalendar = (message) => {
//     return async (dispatch) => {
//         try {
//             const { data } = await blockCalendar(message)
//             Storage.setBusinessRoundStatus(false)
//             dispatch({
//                 type: BLOCK_CALENDAR,
//             })
//         } catch (error) {
//             console.log(error)
//         }
//     }
// }

// export const unBlockCalendar = () => {
//     return async (dispatch) => {
//         try {
//             await unBlockCalendar()
//             Storage.setBusinessRoundStatus(true)
//             dispatch({
//                 type: UNBLOCK_CALENDAR,
//             })
//         } catch (error) {
//             console.log(error);
//         }
//     }
// }